import React from 'react';

import './index.scss';

//custom cpomponents
import CustomButton from '../../../components/basic/CustomButton';


//material ui
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import CustomInput from '../../../components/basic/input'
import CircularProgress from '@material-ui/core/CircularProgress';


//other libraries
import {toJS} from 'mobx';
import { inject, observer } from 'mobx-react';
import { ChromePicker } from 'react-color'; //Chrome, Sketch, Photoshop, Block, Github, Hue, Alpha, Twiter, Circle, Slider
import { api } from '../../../functions/api';




@inject('internal')
@inject('translate')
@observer
export default class EditAddTag extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            loadingBtn: false,
            name: "",
            background: '#fff',
        }
    }

    componentDidMount() {
        if(toJS(this.props.internal.actionEdit.edit)) {
            this.loadTag();
        }
        
    }

    loadTag = async() => {
        this.setState({loading: true})
        let idTag = toJS(this.props.internal.actionEdit.id)
        
        let load_tag = await api({
            method: 'get',
            url: `lists/tags/${idTag}`,
            authorization: this.props.internal.user.access_token,
            
        });
        this.setState({name: load_tag.data.data.name, background: load_tag.data.data.color})
        this.setState({loading: false})
    }

    handleChangeComplete = (color) => {
        this.setState({ background: color.hex });
    };

    createNewTag = async () => {
        if(this.name.state.value !== "" && this.state.background) {
        this.setState({loadingBtn: true})
        let name = this.name.state.value;
        this.setState({name: name})

        let method = 'post'
        let url = 'lists/tags'
        if(toJS(this.props.internal.actionEdit.edit)) {
            method = 'patch';
            url += "/" + toJS(this.props.internal.actionEdit.id)
        }
        
        let create_tag = await api({
            method: method,
            url: url,
            authorization: this.props.internal.user.access_token,
            params: {
                color: this.state.background,
                name: this.name.state.value
            }
        });

        if((create_tag.success === false && create_tag.status === 201) || create_tag.success === true) {
            // this.props.showSnackbar(create_tag.data.message, true, true)
            this.setState({name: "", background: '#fff' })
            this.props.internal.setSnackbar(create_tag.data.message, true)
            this.props.onClose();
        }
        else {
            let resultError = "";
            if(create_tag.data.data.errors) {
                for(let error in create_tag.data.data.errors){
                    resultError += create_tag.data.data.errors[error] + " "
                }
            }
            this.props.internal.setSnackbar( resultError, true)
        }
        this.setState({loadingBtn: false})
        }
        else {
            let resultError = "";
            if(this.name.state.value === "") {
                resultError += this.props.translate.i18n.GLOBAL.ALERTS.TITLE_REQUIRED + " ";
            }
            
            this.props.internal.setSnackbar( resultError, true)
        }
    }

    render() {
        return (
            
            <Dialog
                open={this.props.open}
                onClose={this.props.onClose}
                aria-labelledby="form-dialog-title"

            >
            
                <DialogTitle id="form-dialog-title">{this.props.title}</DialogTitle>
                <DialogContent className={'dialog-tag'}>
                {this.state.loading
                    ?
                    <CircularProgress className={'circular-progress'} />
                    :
                        <div className={'flex edit-category'}>
                            <CustomInput
                                ref={ref => this.name = ref}
                                text={this.props.translate.i18n.MODULES.TAGS.NAME}
                                value={this.state.name !== "" ? this.state.name : ""}
                                id={'title'}
                                className={"w-100"}
                                required
                            />

                            <ChromePicker
                                color={ this.state.background }
                                onChangeComplete={ this.handleChangeComplete }
                                className={'color-picker'}
                            />
                        </div>
                    
                    }
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.onClose} className={'gray-text'}>
                        {this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
                    </Button>
                    <CustomButton
                        className={'w-50'}
                        justText
                        progressBar={this.state.loadingBtn}
                        onClick={this.createNewTag}
                        mystyle={'btn-white-bg'}
                        title={this.props.translate.i18n.GLOBAL.BUTTONS.SAVE}
                        disabled={this.state.loading}
                    />
                    {/* <Button onClick={this.createNewTag} className={'orange-text'}>
                        {this.props.translate.i18n.GLOBAL.BUTTONS.SAVE}
                    </Button> */}
                </DialogActions>
                
            </Dialog>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/tags/EditAdd/index.js